import { ALL_ACTIONS, type PolicyActionEnum } from './actions.js';

/** Characters allowed in an action pattern. `*` matches any run of characters, including `:`. */
const ACTION_PATTERN_CHARS = /^[a-z0-9:*-]+$/;

export function isWellFormedActionPattern(pattern: string): boolean {
  return ACTION_PATTERN_CHARS.test(pattern);
}

/** Glob match supporting only `*`. Iterative, so a pattern can't trigger catastrophic backtracking. */
export function matchesPattern(pattern: string, value: string): boolean {
  let p = 0;
  let v = 0;
  let starP = -1;
  let starV = 0;

  while (v < value.length) {
    if (p < pattern.length && pattern[p] === '*') {
      starP = p;
      starV = v;
      p += 1;
    } else if (p < pattern.length && pattern[p] === value[v]) {
      p += 1;
      v += 1;
    } else if (starP !== -1) {
      p = starP + 1;
      starV += 1;
      v = starV;
    } else {
      return false;
    }
  }

  while (p < pattern.length && pattern[p] === '*') p += 1;
  return p === pattern.length;
}

/** Every catalog action a pattern covers. Empty for a pattern that matches nothing. */
export function expandActionPattern(pattern: string): PolicyActionEnum[] {
  if (!isWellFormedActionPattern(pattern)) return [];
  return ALL_ACTIONS.filter((action) => matchesPattern(pattern, action));
}
